/* eslint-disable linebreak-style */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getMigrationStatus } from 'shared/api/clientMigrationApi';
import { selectSelectedCompany } from 'companies/companies.slice';
import { ClientMigration } from 'client-migration/clientMigration.types';

interface UseMigrationStatusResult {
  status: ClientMigration | null;
  hasMigrated: {
    cobra: boolean;
    cdh: boolean;
  };
  loading: boolean;
  error: string | null;
}

export function useMigrationStatus(): UseMigrationStatusResult {
  const [ status, setStatus ] = useState<ClientMigration | null>(null);
  const [ hasMigrated, setHasMigrated ] = useState({ cobra: false, cdh: false });
  const [ loading, setLoading ] = useState<boolean>(true);
  const [ error, setError ] = useState<string | null>(null);

  const selectedCompany = useSelector(selectSelectedCompany);
  const compid = selectedCompany?.compid;

  useEffect(() => {
    if (!compid) {
      setLoading(false);

      return;
    }

    const fetchStatus = async () => {
      try {
        const data = await getMigrationStatus(compid);
        setStatus(data);
        const now = new Date();

        if (!data) {
          setHasMigrated({ cobra: false, cdh: false });
        } else {
          setHasMigrated({
            cobra: data.cobra_actual_migration_date
              ? new Date(data.cobra_actual_migration_date) <= now
              : false,
            cdh: data.cdh_actual_migration_date
              ? new Date(data.cdh_actual_migration_date) <= now
              : false,
          });
        }
      } catch (err) {
        setError((err as Error).message);
        setStatus(null);
        setHasMigrated({ cobra: false, cdh: false });
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [ compid ]);

  return { status, hasMigrated, loading, error };
}
